import { API } from "api";

export const getformStateListAPI = () => {
    return API.get("api/formstate/getall?page=0&size=0")
                .then((res) => res);
};

